import script from "./HklStoreComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HklStoreComponent.vue?vue&type=script&setup=true&lang=js"

import "./HklStoreComponent.vue?vue&type=style&index=0&id=3baca843&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3baca843"]])

export default __exports__